interface UnsavedChangesGetters {
  hasUnsavedChanges: boolean
}

// The lint rules forbid importing from vuex, so the store is typed by the
// two members this uses.
interface UnsavedChangesStore {
  getters: UnsavedChangesGetters
  watch(
    getter: (state: unknown, getters: UnsavedChangesGetters) => boolean,
    callback: (dirty: boolean) => void
  ): () => void
}

// Mirrors the store's unsaved state onto the page-wide dirty flag, which
// makes Turbolinks visits ask before leaving. Turbolinks visits never fire
// beforeunload, so closing or reloading the tab gets its own handler.
export default function trackUnsavedChanges(
  store: UnsavedChangesStore
): () => void {
  const unwatch = store.watch(
    (_state, getters) => getters.hasUnsavedChanges,
    (dirty) => {
      if (dirty) {
        window.Silverfin.Dirty.setDirty()
      } else {
        window.Silverfin.Dirty.clearDirty()
      }
    }
  )

  const onBeforeUnload = (event: BeforeUnloadEvent): void => {
    if (!store.getters.hasUnsavedChanges) return
    event.preventDefault()
  }
  window.addEventListener('beforeunload', onBeforeUnload)

  return () => {
    unwatch()
    window.removeEventListener('beforeunload', onBeforeUnload)
  }
}
